import { useEffect, useState } from "react";
import { getClientAuthHeaders } from "@/lib/apiAuth";
import { catalogEntryOffer } from "@/lib/landingCatalogCopy";

export function usePublicBillingCatalog(countryCode) {
  const [state, setState] = useState({
    status: "loading",
    billingCountry: undefined,
    catalog: undefined,
    entryOffer: undefined,
  });

  useEffect(() => {
    const controller = new AbortController();
    const code = typeof countryCode === "string" ? countryCode.trim() : "";
    const base = `${process.env.REACT_APP_BACKEND_URL}/api/billing/catalog`;
    const url = code
      ? `${base}?${new URLSearchParams({ country: code }).toString()}`
      : base;

    (async () => {
      try {
        const res = await fetch(url, {
          headers: getClientAuthHeaders(),
          signal: controller.signal,
        });
        if (!res.ok) {
          setState({
            status: "error",
            billingCountry: undefined,
            catalog: undefined,
            entryOffer: null,
          });
          return;
        }
        const body = await res.json();
        const catalog = body.catalog;
        setState({
          status: "ready",
          billingCountry: body.billing_country,
          catalog,
          entryOffer: catalogEntryOffer(body.catalog?.items),
        });
      } catch (err) {
        if (err?.name === "AbortError") return;
        setState({
          status: "error",
          billingCountry: undefined,
          catalog: undefined,
          entryOffer: null,
        });
      }
    })();

    return () => controller.abort();
  }, [countryCode]);

  return state;
}
